import LoginForm from "../components/LoginForm";

export const Login = () => {
    return (
      <div>
        <LoginForm/>
      </div>
    );
  };
  